<script>
	import SveltyPicker from 'svelty-picker';

  export let fromDate;
  export let toDate;
</script>

<div style="display: flex; flex-direction: row;">
  <h6>
    <p>Start Date</p>
  <SveltyPicker bind:value={fromDate}/>
  </h6>
  <h6>
    <p>End Date</p>
  <SveltyPicker bind:value={toDate}/>
  </h6>
</div>




